import React, { useState } from 'react';
import { Mail, Send, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { newsletterAPI } from '../../lib/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const NewsletterForm = ({ variant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await newsletterAPI.subscribe({ email, name: name || null });
      toast.success('Inscrição realizada com sucesso!', {
        description: 'Você receberá nossas novidades por email.'
      });
      setEmail('');
      setName('');
    } catch (error) {
      const message = error.response?.data?.detail || 'Erro ao realizar inscrição';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  if (variant === 'sidebar') {
    return (
      <div className="bg-[#0F5A34] text-white p-6 rounded-sm" data-testid="newsletter-sidebar">
        <div className="flex items-center gap-2 mb-3">
          <Mail size={20} className="text-[#DFAF3A]" />
          <h3 className="font-['Montserrat'] text-sm font-semibold uppercase tracking-wider">
            Newsletter
          </h3>
        </div>
        <p className="text-white/80 text-sm font-['Inter'] mb-4">
          Receba as últimas notícias sobre Portugal no seu email.
        </p>
        <form onSubmit={handleSubmit} className="space-y-3">
          <Input
            type="email"
            placeholder="Seu email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
            data-testid="newsletter-email-sidebar"
          />
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#DFAF3A] hover:bg-[#C59A30] text-[#1A1A1A] font-['Montserrat'] text-sm"
            data-testid="newsletter-submit-sidebar"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : 'Inscrever-se'}
          </Button>
        </form>
      </div>
    );
  }

  // Default full-width variant
  return (
    <section className="bg-[#0F5A34] py-12 md:py-16" data-testid="newsletter-section">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex justify-center mb-4">
            <div className="w-12 h-12 rounded-full bg-[#DFAF3A] flex items-center justify-center">
              <Mail size={24} className="text-[#1A1A1A]" />
            </div>
          </div>
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-white mb-3">
            Fique Por Dentro das Novidades
          </h2>
          <p className="text-white/80 font-['Inter'] text-base mb-6">
            Receba as últimas notícias sobre Portugal, dicas de imigração e ofertas exclusivas diretamente no seu email.
          </p>
          
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <Input
              type="text"
              placeholder="Seu nome"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="bg-white border-0 text-[#1A1A1A] placeholder:text-[#5C5C5C]"
              data-testid="newsletter-name"
            />
            <Input
              type="email"
              placeholder="Seu email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-white border-0 text-[#1A1A1A] placeholder:text-[#5C5C5C]"
              data-testid="newsletter-email"
            />
            <Button
              type="submit"
              disabled={loading}
              className="bg-[#E53935] hover:bg-[#C62828] text-white font-['Montserrat'] text-sm px-6"
              data-testid="newsletter-submit"
            >
              {loading ? (
                <Loader2 size={16} className="animate-spin" />
              ) : (
                <>
                  <Send size={16} className="mr-2" />
                  Inscrever
                </>
              )}
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterForm;
